import React from 'react';

export default function FitnessProfileWeightGoalPaceHint({ message }) {
	if (!message) {
		return null;
	}

	return (
		<p className="mt-2 rounded-lg border border-gray-200/80 bg-gray-50/80 px-2.5 py-2 text-xs leading-relaxed text-gray-600 dark:border-gray-700/80 dark:bg-gray-800/50 dark:text-gray-400">
			{message}
		</p>
	);
}
